import { useTheme } from '@mui/material/styles';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { OnboardingWorkflowProvider } from 'src/contexts/OnboardingWorkflowContext';
import useResponsive from 'src/hooks/useResponsive';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';
import { OnboardingLoginWrapper } from 'src/layouts/OnboardingLoginWrapper';

export const Route = createFileRoute('/(app)/onboarding')({
    component: OnboardingLayout,
    staticData: { useChildRouteLayout: true },
});

function OnboardingLayout() {
    const { spacing, shadows } = useTheme();
    const { isMobile } = useResponsive();

    return (
        <OnboardingLoginWrapper>
            <InnerMaxWidthContainer
                wrapperPropsSx={{
                    width: isMobile ? '100%' : spacing(60),
                    boxShadow: isMobile ? 'none' : shadows[2],
                    backgroundColor: 'common.white',
                    p: isMobile ? 2.5 : 4,
                    pt: isMobile ? 0 : 4,
                }}
            >
                <OnboardingWorkflowProvider>
                    <Outlet />
                </OnboardingWorkflowProvider>
            </InnerMaxWidthContainer>
        </OnboardingLoginWrapper>
    );
}
